export const rotaContratoAberta = [

    {
        path: '/contrato',
        name: 'Todos Contratos',
        component: () => import("@/views/Contratos/Contratos.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Dashboard',
            title: "Todos os Contratos",
            icon: 'mdi-file-document-edit',
            subject: ['Contratos'],
            showMenu: true,
            grupo: "Contratos",
            grupoTitle: "Contratos",

        },
    },
];

export const rotaContratoRestrita = [{

    path: '/:obra/contrato',
    name: 'Contrato',
    component: () => import("@/views/Contratos/Contratos.vue"),
    meta: {
        obraObrigatoria: true,
        breadcrumb: 'Dashboard',
        title: "Contratos",
        icon: 'mdi-file-document-edit',
        subject: ['Contratos'],
        showMenu: true,
        grupo: "Contratos",
        grupoTitle: "Contratos",

    },
},
];